<template>
  <div>
    <ResultList
      v-if="currentComponent == 'List'"
      :results="results"
      :searchString="searchString"
      :trendingActive="trendingActive"
      @goToProduct="goToProduct"
    />
  </div>
</template>

<script>
import { addLog } from '@/api/dssRequest';
import uiHelpers from '@/shared/ui_helpers';
import ResultList from './SearchResults_List.vue';

export default {
  name: 'SearchResults',
  mixins: [uiHelpers],
  props: ['trendingActive', 'results', 'searchString'],
  components: {
    ResultList,
  },
  data() {
    return {
      currentComponent: 'List',
    };
  },
  created() {
    // Jump back to results list when a new search is done from the HomePage
    window.EventBus.listen('search', this.goToList);
  },
  methods: {
    goBackToList() {
      // set the list for products back
      this.currentComponent = 'List';
      // show the event list
      this.$emit('showEvents');
    },
    goToList() {
      this.currentComponent = 'List';
    },
    goToProduct(product) {
      this.$emit('hideSearchMenu');

      // Add user interaction to log
      addLog(
        this.$store.getters['auth/userName'],
        product.Id,
        'Product',
        'Search',
        -1
      );
      // route to the details of the product
      this.goToPage('ProductWithCategory', {
        event_id: product.EventId,
        category_id: product.Categories[0].Id,
        product_id: product.Id,
      });
    },
    onBookRentalProducts() {},
  },
};
</script>
